import React from "react";
import PropTypes from "prop-types";
import { Button } from "@boozallen-uip/uswds-react-core";
import HelpText from "./HelpText";

/**
 * Single related ACR entry (URL + type). Ported from GSA openacr-editor Related.svelte.
 */
export default function Related({
  index,
  url,
  type,
  onUrlChange,
  onUrlBlur,
  onTypeChange,
  onDelete,
  urlError,
}) {
  const idUrl = `related-acr-url-${index}`;
  const idType = `related-acr-type-${index}`;

  return (
    <div className="Related border border-gray-200 rounded p-4 mb-2 bg-gray-50/50">
      <div className="flex justify-between items-center mb-2">
        <span className="font-medium text-gray-700">Related ACR Report {index + 1}</span>
        <Button
          onClick={onDelete}
          outline
          aria-label="Delete related ACR report"
        >
          Delete Related ACR Report
        </Button>
      </div>
      <div className="grid gap-2 md:grid-cols-[1fr_auto]">
        <div>
          <label className="usa-label" htmlFor={idUrl}>
            URL
            <input
              id={idUrl}
              type="url"
              value={url}
              onChange={(e) => onUrlChange(e.target.value)}
              onBlur={onUrlBlur}
              aria-invalid={urlError ? "true" : undefined}
              aria-describedby={urlError ? `${idUrl}-error` : undefined}
              className="usa-input"
              placeholder="https://..."
            />
          </label>
          {urlError && <div id={`${idUrl}-error`} className="field-error">{urlError}</div>}
          <HelpText type="related_acrs" field="url" />
        </div>
        <div>
          <label className="usa-label" htmlFor={idType}>
            Type
            <select
              id={idType}
              value={type}
              onChange={(e) => onTypeChange(e.target.value)}
              className="usa-select"
            >
              <option value="primary">Primary</option>
              <option value="secondary">Secondary</option>
            </select>
          </label>
          <HelpText type="related_acrs" field="type" />
        </div>
      </div>
    </div>
  );
}

Related.propTypes = {
  index: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["primary", "secondary"]).isRequired,
  onUrlChange: PropTypes.func.isRequired,
  onUrlBlur: PropTypes.func,
  onTypeChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  urlError: PropTypes.string,
};

Related.defaultProps = {
  onUrlBlur: undefined,
  urlError: "",
};
